import Ws from "@adonisjs/websocket-client";

export class SocketConnection {
  connect(token) {
    this.ws = Ws(process.env.REACT_APP_FORMOU_WS_API).withApiToken(token).connect();
    this.ws.on("open", () => {
      console.log("Connection initialized");
    });
    this.ws.on("close", () => {
      console.log("Connection closed");
    });
    return this;
  }

  subscribe(channel, handler) {
    if (!this.ws) {
      setTimeout(() => this.subscribe(channel, handler), 1000);
    } else {
      const result = this.ws.subscribe(channel);
      result.on("message", message => {
        console.log("Incoming", message);
        handler(message);
      });
      result.on("error", error => {
        console.error(error);
      });
      return result;
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
      console.log("Disconnected from WebSocket");
    }
  }
}

const socketConnection = new SocketConnection();
export default socketConnection;
